var _path, _rect, _path2, _rect2, _path3, _rect3, _path4, _rect4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlockList(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 17.918 17.918",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.678,0H2.24A2.242,2.242,0,0,0,0,2.24V15.678a2.242,2.242,0,0,0,2.24,2.24H15.678a2.242,2.242,0,0,0,2.24-2.24V2.24A2.242,2.242,0,0,0,15.678,0Zm.747,15.678a.747.747,0,0,1-.747.747H2.24a.747.747,0,0,1-.747-.747V2.24a.747.747,0,0,1,.747-.747H15.678a.747.747,0,0,1,.747.747Z",
    fill: "#555"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    rx: 1,
    transform: "translate(2.959 9.959)",
    fill: "#555"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1,1V4H4V1H1M1,0H4A1,1,0,0,1,5,1V4A1,1,0,0,1,4,5H1A1,1,0,0,1,0,4V1A1,1,0,0,1,1,0Z",
    transform: "translate(2.959 9.959)",
    fill: "#555"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    rx: 1,
    transform: "translate(9.959 9.959)",
    fill: "#555"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1,1V4H4V1H1M1,0H4A1,1,0,0,1,5,1V4A1,1,0,0,1,4,5H1A1,1,0,0,1,0,4V1A1,1,0,0,1,1,0Z",
    transform: "translate(9.959 9.959)",
    fill: "#555"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    rx: 1,
    transform: "translate(2.959 2.959)",
    fill: "#555"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1,1V4H4V1H1M1,0H4A1,1,0,0,1,5,1V4A1,1,0,0,1,4,5H1A1,1,0,0,1,0,4V1A1,1,0,0,1,1,0Z",
    transform: "translate(2.959 2.959)",
    fill: "#555"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    rx: 1,
    transform: "translate(9.959 2.959)",
    fill: "#555"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1,1V4H4V1H1M1,0H4A1,1,0,0,1,5,1V4A1,1,0,0,1,4,5H1A1,1,0,0,1,0,4V1A1,1,0,0,1,1,0Z",
    transform: "translate(9.959 2.959)",
    fill: "#555"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockList);
export default __webpack_public_path__ + "static/media/block_list.facd4859adee7a05ad92be409ccdfc09.svg";
export { ForwardRef as ReactComponent };